import { useState, useEffect } from 'react';
import { api } from '../lib/api.js';

// ─── Pay entity / position roster (Settings → Pay entity & position) ───────
export function PayrollRosterView({ currentUser }) {
  const headers = { 'x-user-id': String(currentUser.id) };
  const [roster, setRoster] = useState([]);
  const [err, setErr] = useState('');

  async function load() {
    try {
      const r = await api('GET', '/api/admin/payroll/roster', null, headers);
      setRoster(r.roster || []);
    } catch (e) { setErr(e.message || String(e)); }
  }
  useEffect(() => { load(); }, []);

  async function update(id, patch) {
    setRoster(rs => rs.map(r => r.id === id ? { ...r, ...patch } : r));
    try {
      await api('PUT', `/api/admin/payroll/roster/${id}`, patch, headers);
    } catch (e) { alert(e.message || e); load(); }
  }

  return (
    <div className="card">
      <div className="text-base font-semibold mb-1">Pay entity & position</div>
      <div className="text-xs text-gray-500 mb-3">
        Pay entity (ETC / NBT) drives which payroll batch the paycheck appears in.
        Position drives tip eligibility — Manager and Roaster get $0 tips.
      </div>
      {err && <div className="text-xs text-red-700 mb-2">{err}</div>}
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', fontSize: 13 }}>
          <thead>
            <tr style={{ textAlign: 'left', borderBottom: '1px solid #e0e0e0' }}>
              <th style={{ padding: 6 }}>Name</th>
              <th style={{ padding: 6 }}>Role (legacy)</th>
              <th style={{ padding: 6 }}>Position</th>
              <th style={{ padding: 6 }}>Pay entity</th>
              <th style={{ padding: 6 }}>Hourly rate</th>
            </tr>
          </thead>
          <tbody>
            {roster.map((u) => (
              <tr key={u.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={{ padding: 6, fontWeight: 600 }}>{u.name}</td>
                <td style={{ padding: 6, color: '#757575' }}>{u.role}</td>
                <td style={{ padding: 6 }}>
                  <select value={u.staff_position || ''}
                    onChange={(e) => update(u.id, { staff_position: e.target.value })}
                    style={{ padding: 4, fontFamily: 'inherit', fontSize: 13, border: '1px solid #d0d4d9', borderRadius: 4 }}>
                    <option value="">— set —</option>
                    {['Barista','Employee','Manager','Roaster'].map((p) => <option key={p} value={p}>{p}</option>)}
                  </select>
                </td>
                <td style={{ padding: 6 }}>
                  <select value={u.pay_entity || ''}
                    onChange={(e) => update(u.id, { pay_entity: e.target.value })}
                    style={{ padding: 4, fontFamily: 'inherit', fontSize: 13, border: '1px solid #d0d4d9', borderRadius: 4 }}>
                    <option value="">— set —</option>
                    {['ETC','NBT'].map((p) => <option key={p} value={p}>{p}</option>)}
                  </select>
                </td>
                <td style={{ padding: 6 }}>
                  <input type="number" step="0.01" min="0"
                    defaultValue={u.hourly_rate ?? ''}
                    onBlur={(e) => {
                      const v = e.target.value === '' ? null : Number(e.target.value);
                      if (v === u.hourly_rate) return;
                      update(u.id, { hourly_rate: v });
                    }}
                    style={{ padding: 4, fontFamily: 'inherit', fontSize: 13, border: '1px solid #d0d4d9', borderRadius: 4, width: 90 }} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
